import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from './serviceWorker';
/** Imports for redux */
import { store, persistedState } from './redux/store';
import { Provider } from 'react-redux';
/** Persist redux state on refresh */
import { PersistGate } from 'redux-persist/integration/react';
import HelmetMeta from './utility/HelmetMeta';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistedState}>
      <HelmetMeta />
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
